export default {
  "brand.name": "Basetao Spreadsheet",
  "nav.home": "Accueil",
  "nav.guide": "Guide d'achat",
  "nav.review": "Avis",
  "nav.shipping": "Livraison",
  "nav.qc": "QC",
  "nav.articles": "Articles",
  "cta.explore": "Découvrir Basetao Spreadsheet",
  "cta.buyNow": "Acheter Maintenant",
  "cta.brand": "Basetao Spreadsheet",
  "cta.readGuide": "Lire le Guide Complet",
  "cta.backHome": "Retour à l'Accueil",
  "cta.visitMain": "Visiter Notre Site Principal",
  "footer.tagline": "Ressources, guides et outils de recherche produit indépendants sur Basetao Spreadsheet.",
  "footer.disclaimer": "Ceci est une ressource d'information indépendante. Les informations peuvent changer et doivent être vérifiées de manière indépendante. Nous ne sommes pas affiliés, approuvés ni liés à un service tiers mentionné.",
  "footer.rights": "Tous droits réservés.",
  "footer.resources": "Ressources",
  "footer.legal": "Mentions légales",
  "lang.en": "English",
  "lang.fr": "Français",
  "lang.de": "Deutsch",
  "lang.es": "Español",
  "lang.pt": "Português",
};